import { useTranslation } from "react-i18next"

import { Skeleton } from "@/components/ui/skeleton"

const SKELETON_ROWS = 5

/**
 * OKS-36 — 5 skeleton rows used while the panel/page first loads.
 * Mirrors `NotificationRow` shape (avatar circle + 2 text lines) per
 * UX Spec §3 — Loading. No spinner.
 */
export function NotificationsLoadingSkeletons() {
  const { t } = useTranslation()
  return (
    <ul
      aria-label={t("notifications.loading.label")}
      aria-busy="true"
      data-testid="notifications-loading-skeletons"
      className="flex flex-col"
    >
      {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
        <li
          key={i}
          className="flex items-start gap-3 border-b px-4 py-3 last:border-b-0"
        >
          <Skeleton className="size-8 shrink-0 rounded-full" />
          <div className="flex flex-1 flex-col gap-1.5">
            <Skeleton className="h-3.5 w-2/3" />
            <Skeleton className="h-3 w-full" />
          </div>
        </li>
      ))}
    </ul>
  )
}
